import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from '../app/endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const cartApi = createApi({
    reducerPath: 'cartApi',
    baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
    tagTypes: ['cart'],
    endpoints: (builder) => ({
        findByCustomerId: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.cartDetailController.findByCustomerId}/${body.id}`,
                    method: 'GET',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
                };
            },
        }),
        saveCartDetail: builder.mutation({
            query(body) {
                return {
                    url: spotFinder.cartDetailController.saveCartDetail,
                    method: 'POST',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
                    body: body.payload,
                };
            },
        }),
        updateCartDetail: builder.mutation({
            query(body) {
                return {
                    url: spotFinder.cartDetailController.updateCartDetail,
                    method: 'PUT',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
                    body: body.payload,
                }
            }
        }),

        findByCartId: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.cartDetailController.findByCartId}/${body.id}`,
                    method: 'GET',
                };
            },
        }),

        deleteCartDetailItem: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.cartDetailController.deleteCartDetailItem}`,
                    method: 'PUT',
                    body: body.payload,
                    headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
                };
            },
        }),
    })
})

export const {
    useFindByCustomerIdMutation,
    useSaveCartDetailMutation,
    useUpdateCartDetailMutation,
    useFindByCartIdMutation,
    useDeleteCartDetailItemMutation,
} = cartApi